import tms from '../services/tmsService';
import { ActionTypes } from '../constants';
import { asyncAction, asyncCall } from "./commonActions";

export const getAccomplishments = (appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_ACCOMPLISHMENTS_REQUEST,
        success: ActionTypes.GET_TMS_ACCOMPLISHMENTS_SUCCESS,
        failure: ActionTypes.GET_TMS_ACCOMPLISHMENTS_FAILURE
    },
    serviceAction: tms.getAccomplishments,
    appCode
});

export const downloadCertificate = (appCode, id, onSuccess) => {
    const serviceFunction = async (accessToken, serviceURL) => {
        tms.downloadCertificate({serviceURL,  accessToken, accomplishmentId: id}).then(
            blob => onSuccess(blob)
        );
    }
    return asyncCall(appCode, serviceFunction);
};

export const getEnrolments = (appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_COURSES_REQUEST,
        success: ActionTypes.GET_TMS_COURSES_SUCCESS,
        failure: ActionTypes.GET_TMS_COURSES_FAILURE
    },
    serviceAction: tms.getEnrolments,
    appCode
});

export const addEnrolment = (appCode, id) => asyncAction({
    actionTypes: {
        request: ActionTypes.ADD_TMS_ENROLMENT_REQUEST,
        success: ActionTypes.ADD_TMS_ENROLMENT_SUCCESS,
        failure: ActionTypes.ADD_TMS_ENROLMENT_FAILURE,
    },
    serviceAction: tms.addEnrolment,
    appCode,
    id
});

export const updateEnrolment = (appCode, id, params) => asyncAction({
    actionTypes: {
        request: ActionTypes.UPDATE_TMS_ENROLMENT_REQUEST,
        success: ActionTypes.UPDATE_TMS_ENROLMENT_SUCCESS,
        failure: ActionTypes.UPDATE_TMS_ENROLMENT_FAILURE,
    },
    serviceAction: tms.updateEnrolment,
    appCode,
    id,
    params
});

export const deleteEnrolment = (appCode, id) => asyncAction({
    actionTypes: {
        request: ActionTypes.DELETE_TMS_ENROLMENT_REQUEST,
        success: ActionTypes.DELETE_TMS_ENROLMENT_SUCCESS,
        failure: ActionTypes.DELETE_TMS_ENROLMENT_FAILURE,
    },
    serviceAction: tms.deleteEnrolment,
    appCode,
    id
});


export const getCourses = (appCode, params) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_COURSES_REQUEST,
        success: ActionTypes.GET_TMS_COURSES_SUCCESS,
        failure: ActionTypes.GET_TMS_COURSES_FAILURE
    },
    serviceAction: tms.getCourses,
    appCode,
    params
});

export const getCourseDetails = (id, appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_COURSE_DETAILS_REQUEST,
        success: ActionTypes.GET_TMS_COURSE_DETAILS_SUCCESS,
        failure: ActionTypes.GET_TMS_COURSE_DETAILS_FAILURE
    },
    serviceAction: tms.getCourseDetails,
    appCode,
    id
});

export const downloadAsset = (id, appCode, onSuccess) => {
    const serviceFunction = async (accessToken, serviceURL) => {
        tms.downloadAsset({serviceURL, accessToken, id}).then(
            blob => onSuccess(blob)
        );
    }
    return asyncCall(appCode, serviceFunction);
};

export const getLibrary = (appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_LIBRARY_REQUEST,
        success: ActionTypes.GET_TMS_LIBRARY_SUCCESS,
        failure: ActionTypes.GET_TMS_LIBRARY_FAILURE
    },
    serviceAction: tms.getLibrary,
    appCode
});

export const getCategoryDetails = (id, appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_CATEGORY_DETAILS_REQUEST,
        success: ActionTypes.GET_TMS_CATEGORY_DETAILS_SUCCESS,
        failure: ActionTypes.GET_TMS_CATEGORY_DETAILS_FAILURE
    },
    serviceAction: tms.getCategoryDetails,
    appCode,
    id
});

export const getCategoryCourses = (id, appCode, params) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_COURSES_REQUEST,
        success: ActionTypes.GET_TMS_COURSES_SUCCESS,
        failure: ActionTypes.GET_TMS_COURSES_FAILURE
    },
    serviceAction: tms.getCategoryCourses,
    appCode,
    id,
    params
});

export const updateModuleEnrolment = (appCode, id, params, callback) => asyncAction({
    actionTypes: {
        request: ActionTypes.UPDATE_TMS_MODULE_ENROLMENT_REQUEST,
        success: ActionTypes.UPDATE_TMS_MODULE_ENROLMENT_SUCCESS,
        failure: ActionTypes.UPDATE_TMS_MODULE_ENROLMENT_FAILURE
    },
    serviceAction: tms.updateModuleEnrolment,
    appCode,
    id,
    callback,
    params
});

export const retakeModule = (appCode, id, callback, params) => asyncAction({
    actionTypes: {
        request: ActionTypes.RETAKE_TMS_MODULE_REQUEST,
        success: ActionTypes.RETAKE_TMS_MODULE_SUCCESS,
        failure: ActionTypes.RETAKE_TMS_MODULE_FAILURE
    },
    serviceAction: tms.retakeModule,
    appCode,
    id,
    callback,
    params
});

export const getLaunchURL = (moduleId, appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_LAUNCH_URL_REQUEST,
        success: ActionTypes.GET_TMS_LAUNCH_URL_SUCCESS,
        failure: ActionTypes.GET_TMS_LAUNCH_URL_FAILURE
    },
    serviceAction: tms.getLaunchURL,
    appCode,
    moduleId,
    id: moduleId,
    suppressErrors: true
});


export const getEvents = (appCode, params) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_EVENT_LIST_REQUEST,
        success: ActionTypes.GET_TMS_EVENT_LIST_SUCCESS,
        failure: ActionTypes.GET_TMS_EVENT_LIST_FAILURE
    },
    serviceAction: tms.getEvents,
    appCode,
    params
});

export const getEvent = (appCode, id) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_EVENT_REQUEST,
        success: ActionTypes.GET_TMS_EVENT_SUCCESS,
        failure: ActionTypes.GET_TMS_EVENT_FAILURE
    },
    serviceAction: tms.getEvent,
    appCode,
    id
});

export const getEventAttendances = (appCode, params) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_TMS_EVENT_BOOKING_LIST_REQUEST,
        success: ActionTypes.GET_TMS_EVENT_BOOKING_LIST_SUCCESS,
        failure: ActionTypes.GET_TMS_EVENT_BOOKING_LIST_FAILURE
    },
    serviceAction: tms.getEventAttendances,
    appCode,
    params
});

export const bookEvent = (eventId, moduleId, appCode, eventDate = null) => asyncAction({
    actionTypes: {
        request: ActionTypes.ADD_TMS_EVENT_BOOKING_REQUEST,
        success: ActionTypes.ADD_TMS_EVENT_BOOKING_SUCCESS,
        failure: ActionTypes.ADD_TMS_EVENT_BOOKING_FAILURE
    },
    serviceAction: tms.bookEvent,
    appCode,
    eventId,
    moduleId,
    eventDate
});

export const updateEventBooking = (attendanceId, appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.UPDATE_TMS_EVENT_BOOKING_REQUEST,
        success: ActionTypes.UPDATE_TMS_EVENT_BOOKING_SUCCESS,
        failure: ActionTypes.UPDATE_TMS_EVENT_BOOKING_FAILURE
    },
    serviceAction: tms.updateEventBooking,
    appCode,
    attendanceId
});

export const deleteEventBooking = (attendanceId, moduleId, appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.DELETE_TMS_EVENT_BOOKING_REQUEST,
        success: ActionTypes.DELETE_TMS_EVENT_BOOKING_SUCCESS,
        failure: ActionTypes.DELETE_TMS_EVENT_BOOKING_FAILURE
    },
    serviceAction: tms.deleteEventBooking,
    appCode,
    attendanceId,
    moduleId
});

const tmsActions = {
    getAccomplishments,
    downloadCertificate,
    getEnrolments,
    addEnrolment,
    updateEnrolment,
    deleteEnrolment,
    getCourses,
    getCourseDetails,
    downloadAsset,
    getLibrary,
    getCategoryDetails,
    getCategoryCourses,
    updateModuleEnrolment,
    retakeModule,
    getLaunchURL,
    getEvents,
    getEvent,
    getEventAttendances,
    bookEvent,
    updateEventBooking,
    deleteEventBooking
};

export default tmsActions;
